var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test-chart-container"},[_c('div',{staticClass:"Chart"},[(_vm.loading)?_c('div',{staticClass:"loader"}):_vm._e(),_c('h4',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.name))]),_c('mixed-chart',{style:(_vm.myStyles),attrs:{"data":_vm.dataPoints}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }